
import React, { PureComponent } from 'react';

export default class SettingsIcon extends PureComponent {

    render() {
        const { color, isDrawer } = this.props
        return (
            <svg style={isDrawer ? {scale: '1.3'} : {}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 10C9.1046 10 10 9.1046 10 8C10 6.8954 9.1046 6 8 6C6.8954 6 6 6.8954 6 8C6 9.1046 6.8954 10 8 10Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.0816 6.92994L12.3498 5.16287L13.3334 3.99967L12 2.66634L10.8432 3.65497L9.03857 2.91283L8.62357 1.33301H7.32071L6.89944 2.93376L5.13631 3.67698L4.00004 2.66634L2.66671 3.99967L3.63562 5.19224L2.91504 6.96387L1.33337 7.33301V8.66634L2.93411 9.10334L3.67721 10.8661L2.66671 11.9997L4.00004 13.333L5.19415 12.3599L6.93137 13.0745L7.33337 14.6663H8.66671L9.06971 13.0751L10.8368 12.3433C11.1313 12.5539 12 13.333 12 13.333L13.3334 11.9997L12.344 10.8326L13.076 9.06501L14.6666 8.65114L14.6667 7.33301L13.0816 6.92994Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        )
    }
}
